import { Breakpoint } from '@mui/material';
import { useEffect, useState } from 'react';
import theme from '../config/theme';

export const useViewport = (breakpoint: Breakpoint = 'md') => {
  const [width, setWidth] = useState(globalThis.innerWidth);

  useEffect(() => {
    const handleWindowResize = () => setWidth(globalThis.innerWidth);
    globalThis.addEventListener('resize', handleWindowResize);
    return () => globalThis.removeEventListener('resize', handleWindowResize);
  }, []);

  return {
    width,
    isSmallViewport: width < theme.breakpoints.values[breakpoint]
  };
};
